import React from 'react';
import { Box, styled } from '@mui/material';
import CustomTag from '../../../../../Components/CustomTag';
import { toTitleCase } from '../../../../../Helper/Formatters/TextFormatter';
import { alertTagStyles } from '../../../../../Helper/DigitalTwin/DataFile';

const TableTagContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center'
}));

const TAG_STYLES = {
    ...alertTagStyles
};

const getTagStyles = (config, record) => {
    const dataIndex = config?.dataIndex;
    const raw = record?.[dataIndex];
    const value = typeof raw === 'string' ? raw.toLowerCase() : null;

    if (!dataIndex || !TAG_STYLES[dataIndex]) {
        return TAG_STYLES.alertStatus.default;
    }

    return (value && TAG_STYLES[dataIndex][value]) || TAG_STYLES[dataIndex].default;
};

const TableTagView = ({ record, config }) => {
    const value = record?.[config?.dataIndex];
    const tagStyles = getTagStyles(config, record);
    const { backgroundColor, fontColor, iconColor, ...restStyles } = tagStyles;
    const iconName = config?.icon;

    const iconProps = {
        sx: { color: iconColor, fontSize: '9px' }
    };

    return (
        <TableTagContainer>
            <CustomTag
                icon={iconName}
                iconProps={iconProps}
                text={toTitleCase(value)}
                backgroundColor={backgroundColor}
                fontColor={fontColor}
                tooltipText={false}
                containerStyle={restStyles}
            />
        </TableTagContainer>
    );
};

export default TableTagView;
